var map = {
	"./X33-Mall_small.jpg": 922,
	"./all.svg": 923,
	"./apple-watch.png": 924,
	"./b-headphone.png": 925,
	"./coin.svg": 926,
	"./delete-btn.svg": 927,
	"./iphone-13.webp": 2370,
	"./iphone-pink.png": 928,
	"./love.svg": 929,
	"./mall-banner-cn.jpg": 930,
	"./mall-banner-id.jpg": 931,
	"./mall-banner-ms.jpg": 932,
	"./mall-banner-vn.webp": 2371,
	"./mall-banner.jpg": 933,
	"./mobile-bg.jpg": 934,
	"./price-high.svg": 935,
	"./price-low.svg": 936,
	"./shopping-cart.svg": 937,
	"./star.svg": 938
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2369;